import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Accept: "application/json" },
});

const getBaseUrl = (envVar, localUrl) => {
  return process.env[envVar] ? process.env[envVar] : localUrl;
};

// function to obtain user roles
async function getUserInfo() {
  if (process.env.REACT_APP_IS_LOCAL_ENV === "true") {
    return {
      dev: process.env.REACT_APP_API_KEY,
      test: process.env.REACT_APP_API_KEY,
      prod: process.env.REACT_APP_API_KEY,
    };
  }
  const response = await fetch("/.auth/me");
  const payload = await response.json();
  const { clientPrincipal } = payload;
  const claims = clientPrincipal.claims;
  const roleApiKeyMap = {};
  const roles = [];
  claims.forEach((claim) => {
    if (claim["typ"] === "api_keys") {
      const [role, apiKey] = claim["val"].split("---");
      if (role && apiKey) {
        roleApiKeyMap[role] = apiKey;
      }
    } else if (claim["typ"] === "groups") {
      roles.push(claim["val"]);
    }
  });
  sessionStorage.setItem("userRoles", JSON.stringify(roles));
  const storedValue = sessionStorage.getItem("userRole");
  const role = storedValue ? JSON.parse(storedValue) : "";
  if (!roles.includes(role) && roles.length > 0) {
    sessionStorage.setItem("userRole", JSON.stringify(roles[0]));
  }
  return roleApiKeyMap;
}

function getSelectedApiKey(apiKeys) {
  try {
    const storedValue = sessionStorage.getItem("userRole");
    const role = storedValue ? JSON.parse(storedValue) : "dev";
    return apiKeys[role];
  } catch (error) {
    console.error("Error parsing userRole:", error);
    return apiKeys.dev;
  }
}

async function setApiKey(config) {
  const apiKeys = await getUserInfo();
  const apiKey = getSelectedApiKey(apiKeys);
  config.headers["X-Api-Key"] = apiKey;
  return config;
}

// Interceptor to modify the request before send
api.interceptors.request.use(setApiKey, (error) => {
  return Promise.reject(error);
});

function setApisURLS(role) {
  if (role.toLowerCase().endsWith("prod")) {
    api.defaults.baseURL = getBaseUrl("REACT_APP_API_URL_PROD");
  } else {
    api.defaults.baseURL = getBaseUrl("REACT_APP_API_URL");
  }
}

export default api;
export { getUserInfo, setApisURLS, getSelectedApiKey };
